<template>
<div class="page" v-loading="loading">
    <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <el-row>
        <el-col :span="18">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item>
                    <el-input v-model="filter.keyword" placeholder="搜索名称 / 编码" size="mini" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSearch" size="mini">查询</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col :span="6" style="text-align: right;">
            <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="onCreate">新增</el-button>
        </el-col>
    </el-row>

    <el-tabs v-model="actTab" type="card" tab-position="top" @tab-click="changeTab">
        <el-tab-pane :label="'上架(' + counts[0] + ')'" name="1"></el-tab-pane>
        <el-tab-pane :label="'下架(' + counts[1] + ')'" name="0"></el-tab-pane>
    </el-tabs>

    <el-table :data="tableData" style="width: 100%; margin-bottom: 20px;" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column type="index" label="序号" width="50px"></el-table-column>
        <el-table-column prop="thumb" label="图片" width="100">
            <template slot-scope="scope">
                <el-image :src="scope.row.thumb" fit="fill"></el-image>
            </template>
        </el-table-column>
        <el-table-column prop="title" label="名称" width="300">
            <template slot-scope="scope">
                <h3 style="margin: 0;">{{scope.row.title}} ID:{{scope.row.id}}</h3>
                <p style="margin: 0;">落地名称：{{scope.row.small_title}}</p>
                <el-tag type="info" size="mini" effect="dark" v-for="(tag,i) in scope.row.tags" :key="i">{{tag}}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="sale_price" label="售价"></el-table-column>
        <el-table-column prop="original_price" label="原价"></el-table-column>
        <el-table-column prop="cost_price" label="成本价"></el-table-column>
        <el-table-column label="操作" width="355px">
            <template slot-scope="scope">
                <el-button size="mini" type="info" @click="onCopy(scope.row)">复制</el-button>
                <!-- <el-button size="mini" type="success" @click="onSku(scope.row)">属性</el-button> -->
                <el-button size="mini" type="primary" @click="onEdit(scope.row)">编辑</el-button>
                <el-popconfirm placement="top" confirm-button-text='删除' cancel-button-text='取消' icon-color="red" title="确定删除吗？" @confirm="onDel(scope.row)" class="btn-pop">
                    <el-button type="danger" size="mini" slot="reference">删除</el-button>
                </el-popconfirm>
                 <el-button v-if="commissionPower==1" size="mini" class="btn-pop" type="warning" @click="onCommission(scope.row)">提成</el-button>
            </template>
        </el-table-column>
    </el-table>

    <el-pagination background layout="prev, pager, next,total" :page-size="pagesize" :page-count="maxpage" :total="total" @current-change="pageChange"></el-pagination>

    <el-dialog title="编辑信息" :visible.sync="infoShow" width="70%" @close="resetInfo" :close-on-click-modal="false">
        <el-form :model="info" ref="info" :rules="rules" label-width="200px" :inline="false" size="small" style="height: 350px;overflow-y:scroll;">
            <el-form-item label="名称" prop="title">
                <el-input v-model="info.title"></el-input>
            </el-form-item>
            <el-form-item label="落地名称" prop="small_title">
                <el-input v-model="info.small_title"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="thumb">
                <el-upload class="img-uploader" :action="uploadUrl" :show-file-list="false" list-type="picture-card" :before-upload="beforeUpload" :on-success="uploadSuccess">
                    <img v-if="info.thumb" :src="info.thumb" class="img">
                    <i v-else class="el-icon-plus img-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="轮播图" prop="album">
                <el-upload class="img-uploader" :action="uploadUrl" multiple :limit="5" list-type="picture-card" :on-success="uploadAlbumSuccess" :before-upload="beforeUpload" :file-list="currentAlbum" :on-remove="albumRemove">
                    <i class="el-icon-plus img-uploader-icon"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="是否为疫苗产品" prop="is_vaccine">
                <el-switch v-model="info.is_vaccine" :active-value="1" :inactive-value="0" @change="computeCost()">
                </el-switch>
            </el-form-item>

            <el-form-item label="原价" prop="original_price">
                <el-input v-model="info.original_price"></el-input>
            </el-form-item>
            <el-form-item label="售价" prop="sale_price" >
                <el-input v-model="info.sale_price"  @blur="computeCost()"></el-input>
            </el-form-item>
           
            <el-form-item label="会员价" prop="member_price">
                <el-input v-model="info.member_price"></el-input>
            </el-form-item>
            <el-form-item label="企业价" prop="company_price">
                <el-input v-model="info.company_price"></el-input>
            </el-form-item>
            <el-form-item label="有无实物" prop="is_real">
                <el-switch v-model="info.is_real" :active-value="1" :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="是否为自检产品" prop="is_self">
                <el-switch v-model="info.is_self" :active-value="1" :inactive-value="0">
                </el-switch>
            </el-form-item>
            
            <el-form-item label="是否需要预约" prop="need_visit">
                <el-switch v-model="info.need_visit" :active-value="1" :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="附加项" prop="is_extend">
                <el-switch v-model="info.is_extend" :active-value="1" :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="多次消费长产品" prop="is_multiple">
                <el-switch v-model="info.is_multiple" :active-value="1" :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="每次间隔/天(,号隔开)" prop="multiple_dates">
                <el-input v-model="info.multiple_dates" placeholder="如:九价的后两针: 第二针与第一针隔60天,第三针与第二针隔120天，即60,120" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-switch v-model="info.status" :active-value="1" :inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="详情">
                <quill-editor v-model="info.detail" ref="myQuillEditor" :options="editorOption"></quill-editor>
            </el-form-item>
        </el-form>

        <span slot="footer">
            <el-button @click="infoShow = false">取消</el-button>
            <el-button type="primary" @click="subInfo">提交</el-button>
        </span>
    </el-dialog>

    <el-dialog title="设置属性" :visible.sync="showSku" width="60%" @close="clearSku">
        <el-form label-width="100px" :inline="false" size="mini">
            <el-form-item label="属性">
                <el-select v-model="skuAttrs" multiple filterable allow-create default-first-option placeholder="添加属性">
                    <el-option v-for="(attr,i) in skuAttrs" :key="i" :label="attr" :value="attr">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="attr" v-for="(attr,i) in skuAttrs" :key="i">
                <el-select v-model="skuOptions[i]" multiple filterable allow-create default-first-option placeholder="添加选项">
                    <el-option v-for="(item,j) in skuOptions[i]" :key="j" :label="item" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="buildSku">生成SKU</el-button>
            </el-form-item>
        </el-form>

        <div class="sku-item" v-for="(item,i) in skuList" :key="i">
            <span v-for="(col,j) in item.attrs" :key="j" class="sku-title">{{col}}</span>
            <span class="sku-content">成本价：<el-input size="mini" v-model="skuList[i].cost_price" style="width: 100px;"></el-input></span>
            <span class="sku-content">市场价：<el-input size="mini" v-model="skuList[i].original_price" style="width: 100px;"></el-input></span>
            <span class="sku-content">售价：<el-input size="mini" v-model="skuList[i].sale_price" style="width: 100px;"></el-input></span>
        </div>

        <span slot="footer">
            <el-button @click="showSku = false">取消</el-button>
            <el-button type="primary" @click="subSku">设置</el-button>
        </span>
    </el-dialog>

</div>
</template>

<script>
import {
    quillEditor
} from 'vue-quill-editor'
import {
    quillRedefine
} from 'vue-quill-editor-upload'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
    components: {
        quillEditor
    },
    data() {
        return {
            loading: false,
            filter: {
                keyword: '',
                status: 1,
            },
            actTab: '1',
            tableData: [],
            counts: [],
            page: 1,
            maxpage: 1,
            pagesize: 20,
            total: 0,
            infoShow: false,
            saveType: 1, // 1新增 2编辑
            info: {
                title: '',
                thumb: '',
                cost_price: '',
                original_price: '',
                sale_price: '',
                is_real: 0,
                is_self: 0,
                is_vaccine:0,
                need_visit: 1,
                is_extend: 0,
                is_multiple: 0,
                multiple_dates: '',
                status: 1,
                album:[]
            },
            rules: {
                title: [{
                    required: true,
                    message: '请填写名称',
                    trigger: 'blur'
                }],
                name: [{
                    required: true,
                    message: '请填写标识',
                    trigger: 'blur'
                }],
            },
            showSku: false,
            skuAttrs: [],
            skuOptions: [],
            skuList: [],
            currentGoodId: 0,
            currentAlbum: [],
            uploadUrl: this.$util.host + '/upload?type=goods',
            editorOption: {},
            shops: [],
            commissionPower:0,
            goodCommissionList:[],
            addCommissionIndex:0,
            goodCommission:{
                good_id:0,
                guide_commission:0,
                vcode_commission:0,
                appointment_commission:0,
                commission_strat_time:'',
                commission_end_time:'',
                add: true,
                edit:false,
                index:0,
                store_ids:[]
            },
            showCommissionEdit:false,
            stores:[]
        }
    },
    mounted() {
        this.getTableData()
        this.editorOption = quillRedefine({
            // 图片上传的设置
            uploadConfig: {
                action: this.uploadUrl, // 必填参数 图片上传地址
                // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
                // 你必须把返回的数据中所包含的图片地址 return 回去
                res: (respnse) => {
                    return respnse.data // 这里切记要return回你的图片地址
                },
                name: 'file'
            }
        })
    },
    methods: {
        getTableData() {
            this.loading = true
            let data = this.filter
            data.page = this.page
            this.tableData=[];
            this.$util.get('goods', data).then(res => {
                this.loading = false
                this.tableData = res.data
                this.maxpage = res.last_page
                this.pagesize = res.per_page
                this.total = res.total
                this.counts = res.counts
                this.commissionPower=res.hasCommissionPower
            })
        },
        changeTab(val){
            this.filter.status = val.name
            this.getTableData()
        },
        onSearch() {
            this.page = 1
            this.maxpage= 1
            this.total= 0
            this.getTableData()
        },
        pageChange(page) {
            this.page = page
            this.getTableData()
        },
        onCreate() {
            this.currentAlbum = []
            this.saveType = 1
            this.infoShow = true
        },
        onEdit(row) {
            this.saveType = 2
            this.info = {
                id: row.id,
                title: row.title,
                small_title: row.small_title,
                thumb: row.thumb,
                cost_price: row.cost_price,
                original_price: row.original_price,
                sale_price: row.sale_price,
                member_price: row.member_price,
                company_price: row.company_price,
                is_real: row.is_real,
                is_self: row.is_self,
                need_visit: row.need_visit,
                is_extend: row.is_extend,
                is_multiple: row.is_multiple,
                multiple_dates: row.multiple_dates,
                status: row.status,
                detail: row.detail,
                is_vaccine:row.is_vaccine,
                album:[...row.album]
            }
            this.currentAlbum = []
            row.album.forEach(album => {
                this.currentAlbum.push({
                    url: album
                })
            });
            this.infoShow = true
        },
        onDel(row) {
            console.log(row.id)
        },
        onQuick(id, field, val) {
            this.$util.put('goods/quick/' + id, {
                field: field,
                value: val
            }).then(() => {
                this.getTableData()
            })
        },
        onCopy(row) {
            this.saveType = 1
            this.info = {
                title: row.title,
                small_title: row.small_title,
                thumb: row.thumb,
                cost_price: row.cost_price,
                original_price: row.original_price,
                sale_price: row.sale_price,
                member_price: row.member_price,
                company_price: row.company_price,
                is_real: row.is_real,
                is_self: row.is_self,
                need_visit: row.need_visit,
                is_extend: row.is_extend,
                is_multiple: row.is_multiple,
                multiple_dates: row.multiple_dates,
                status: row.status,
                detail: row.detail,
                is_vaccine:row.is_vaccine,
                album:[...row.album]
            }
            this.currentAlbum = []
            row.album.forEach(album => {
                this.currentAlbum.push({
                    url: album
                })
            });
        },
        subInfo() {
            this.$refs['info'].validate((valid) => {
                if (valid) {
                    console.log(this.info);
                    if (this.saveType == 1) {
                        this.$util.post('goods', this.info).then((res) => {
                            if(res.code != 0){
                                return this.$message(res.msg?res.msg:'');
                            }else{
                                this.getTableData()
                                this.infoShow = false
                            }
                           
                        })
                    } else {
                        this.$util.put('goods/' + this.info.id, this.info).then((res) => {
                            if(res.code != 0){
                                return this.$message(res.msg?res.msg:'');
                            }else{
                                this.getTableData()
                                this.infoShow = false
                            }
                        })
                    }
                } else {
                    return false;
                }
            })
        },
        onSku(row) {
            this.currentGoodId = row.id
            this.skuList = [];
            row.skus.forEach(sku => {
                this.skuList.push(sku)
            });
            this.skuAttrs = row.sku_attr
            this.skuOptions = row.sku_option
            this.showSku = true
        },
        clearSku() {

        },
        descartes(array) {
            if (array.length < 2) {
                var t = [];
                for (const i in array[0].options) {
                    t.push([array[0].options[i]]);
                }
                return t;
            }

            return [].reduce.call(array, function (col, set) {
                var res = [];
                col.options.forEach(function (c) {
                    set.options.forEach(function (s) {
                        var t = [].concat(Array.isArray(c) ? c : [c]);
                        t.push(s);
                        res.push(t);
                    })
                });
                return res;
            });
        },
        buildSku() {
            let tempList = [];
            const temp = this.descartes(this.skuTree)
            for (const i in temp) {
                let flag = 0;
                let hasSku = {}
                for (let j = 0; j < this.skuList.length; j++) {
                    const sku = this.skuList[j];
                    if (sku.attrs.join(',') == temp[i].join(',')) {
                        flag = 1
                        hasSku = sku
                    }
                }
                if (flag == 1) {
                    tempList.push(hasSku)
                } else {
                    tempList.push({
                        attrs: temp[i]
                    })
                }
            }
            this.skuList = tempList
        },
        subSku() {
            this.$util.put('good/goods/sku/' + this.currentGoodId, {
                skus: this.skuList,
                skuAttrs: this.skuAttrs,
                skuOptions: this.skuOptions
            }).then(() => {
                this.showSku = false
                this.getTableData()
            })
        },
        setSkuOption(i, val) {
            this.skuOptions[i] = val
        },
        resetInfo() {
            this.info = {
                title: '',
                thumb: '',
                cost_price: '',
                original_price: '',
                sale_price: '',
                is_real: 0,
                is_self: 0,
                need_visit: 1,
                is_extend: 0,
                is_multiple: 0,
                multiple_dates: '',
                status: 1,
                is_vaccine:0,
            }
        },
        uploadSuccess(res) {
            this.info.thumb = res.data;
        },
        uploadAlbumSuccess(res) {
            this.info.album.push(res.data);
            console.log('album',this.info.album)
        },
        albumRemove(file, fileList) {
            this.info.album = []
            fileList.forEach(item => {
                this.info.album.push(item.url)
            });
        },
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isPNG) {
                this.$message.error('上传头像图片只能是 JPG,PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return (isJPG || isPNG) && isLt2M;
        },
        addCommison(){
            //console.log('goodCommissionList',this.goodCommissionList);
            this.goodCommission.index=this.addCommissionIndex+1;
            this.goodCommissionList.push({...this.goodCommission});
        },
        saveCommison(row){
            //console.log(row);
            let info = {
                good_id: row.good_id,
                guide_commission: row.guide_commission,
                vcode_commission: row.vcode_commission,
                appointment_commission: row.appointment_commission,
                commission_strat_time: row.commission_strat_time,
                commission_end_time:row.commission_end_time,
                status:1,
                store_ids:row.store_ids
            }
            if(info.commission_strat_time && !info.commission_end_time || !info.commission_strat_time && info.commission_end_time ){
                return this.$message('请正确选择日期');
            }
            if(row.add){
                this.$util.post('good/good_commission', info).then((res) => {
                    if(res.code !=0){
                        this.$message(res.msg?res.msg:'操作失败');
                    }else{
                        this.goodCommissionList.forEach((ele,key) => {
                            if(ele.index){
                                this.goodCommissionList.splice(key,1)
                            }
                        });
                        //console.log(res.data)
                        let newdata={...res.data}
                        newdata.add=false
                        newdata.edit=false
                        this.goodCommissionList.push(newdata)
                    }
                })
            }else if(row.edit){
                this.$util.put('good/good_commission/'+row.id, info).then((res) => {
                    if(res.code !=0){
                        this.$message(res.msg?res.msg:'操作失败');
                    }else{
                        console.log('save',res);
                        let newdata={...res.data}
                        this.goodCommissionList.forEach(ele => {
                            if(ele.id == row.id){
                                ele.edit=false
                                ele.store_titles=newdata.store_titles
                            }
                        });
                    }
                })
            } 

        },
        editCommission(row){
            this.goodCommissionList.forEach((item)=>{
                if(item.id == row.id){
                    item.edit=true;
                }
            });
        },
        delCommission(row){
            this.$confirm('确定删除？').then(()=>{
                if(!row.index){
                    this.$util.put('good/good_commission/quick/'+row.id, {
                        field:'status',
                        value:0
                    }).then((res) => {
                        if(res.code !=0){
                            this.$message(res.msg?res.msg:'操作失败');
                        }else{
                            this.goodCommissionList.forEach((item,key)=>{
                                if(item.id == row.id){
                                    this.goodCommissionList.splice(key,1)
                                }
                            });
                        }
                    })
                }else{
                    this.goodCommissionList.forEach((item,key)=>{
                        if(item.index == row.index){
                            this.goodCommissionList.splice(key,1)
                        }
                    });
                }

            }).catch(()=>{});
        },
        onCommission(row){
            this.showCommissionEdit=true
            this.goodCommission.good_id=row.id
            this.goodCommissionList=[];
            this.$util.get('good/good_commission', {good_id:this.goodCommission.good_id}).then(res => {
                 res.data.forEach(item => {
                    item.add=false
                    item.edit=false
                    this.goodCommissionList.push(item)
                });
            })
            this.getStores()
            // this.goodCommission.guide_commission=row.guide_commission
            // this.goodCommission.vcode_commission=row.vcode_commission
            // this.goodCommission.appointment_commission=row.appointment_commission
            // this.goodCommission.commission_strat_time=row.commission_strat_time
            // this.goodCommission.commission_end_time=row.commission_end_time
        },
        commissionEditCancel(){
            this.showCommissionEdit=false
            this.goodCommission={
                good_id:0,
                guide_commission:0,
                vcode_commission:0,
                appointment_commission:0,
                commission_strat_time:'',
                commission_end_time:'',
                add: true,
                edit:false,
                store_ids:[]
            }
        },
        commissionEditSubmitFunc(){
            if(this.goodCommission.good_id<=0){
                this.$message('获取套餐参数失败');
                return false;
            }
            this.$util.put('good/goods/commission/' + this.goodCommission.good_id, this.goodCommission).then((res) => {
                if(res.code !=0){
                    this.$message(res.msg?res.msg:'修改失败');
                }else{
                    this.commissionEditCancel();
                    this.getTableData()
                }
            })
        },
         getStores() {
            this.$util.get('slc', {
                model: 'Store'
            }).then(res => {
                this.stores = res
            })
        },
        computeCost(){
            if(this.info.is_vaccine==1){
                let cost=(parseFloat(this.info.sale_price) * 0.9).toFixed(2)
                this.info.cost_price_man=cost
                this.info.cost_price_female_unmarried=cost
                this.info.cost_price_female_married=cost
            }

        }
    },
    computed: {
        skuTree() {
            let tree = []
            this.skuAttrs.forEach((attr, i) => {
                tree.push({
                    label: attr,
                    key: Date.now(),
                    options: this.skuOptions[i]
                })
            })
            return tree
        }
    }
}
</script>

<style scoped>
.btn-pop {
    margin-left: 10px;
}

.sku-title {
    margin-right: 10px;
}

.sku-item {
    margin-bottom: 20px;
}

.sku-content {
    margin-right: 20px;
}

/* .img-uploader {
    width: 80px;
    height: 80px;
    border: #DCDFE6 1px solid;
} */

.img-uploader /deep/ .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 90px;
}

.img-uploader /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
}

/* .img-uploader-icon {
    font-size: 26px;
    color: #DCDFE6;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
} */
.el-tag {
    margin-right: 10px;
}

.img {
    width: 80px;
    height: 80px;
}

.quill-editor /deep/ .ql-container {
    min-height: 300px;
}

.el-transfer /deep/ .el-transfer-panel {
    width: 300px;
}
</style>
